module.exports = __webpack_public_path__ + "static/mobile-6c29e4c41e707b0c171f0bc29fe47d5a.png";